import {Injectable} from '@angular/core';

@Injectable()
export class FabMessageService {
  showFabFlag = false;
  showFabMessage = 'NM';

  constructor() {
  }

  showFab(fabType) {
    if (fabType === 0) {
      this.showFabFlag = false;
      this.showFabMessage = 'NM';
    }
    if (fabType === 1) {
      this.showFabMessage = 'WORKING_TIME_RECORDED';
      this.showFabFlag = true;
    }
    if (fabType === 2) {
      this.showFabMessage = 'WTINLITFT';
      this.showFabFlag = true;
    }
  }

  isAuthenticated() {
    const isAuthenticated = localStorage.getItem('Authenticated');
    if (isAuthenticated !== undefined) {
      return isAuthenticated;
    }
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/fab-message.service.ts